import { ReactNode } from 'react'
import { PanelError } from '@/console/api/errors'
import { Callout } from '@/console/ui/Callout'
import styles from './Warehouse.module.css'

/**
 * LOGISPRD-15602 — 정책 카드 공통 틀. 헤더(제목 · type 상수명 · 태그) / 본문 / 푸터(우측 정렬 버튼) 3단이다.
 * `section[aria-label]` 이라 region 으로 잡힌다. 저장 실패는 본문 아래, 푸터 위에 보인다(입력 바로 밑에서 읽히게).
 */
export const PolicyCard = ({
  title,
  typeName,
  tags,
  error,
  footer,
  footerNote,
  flush,
  children,
}: {
  title: string
  /** 헤더의 흐린 mono 표기. 여러 type 을 묶은 카드는 생략한다. */
  typeName?: string
  tags?: ReactNode
  error?: ReactNode
  /** 우측 버튼들. 없으면 푸터를 그리지 않는다. */
  footer?: ReactNode
  /** 푸터 왼쪽의 흐린 보조 문구(예: 저장 결과). */
  footerNote?: ReactNode
  /** 본문 좌우 여백 없이 — 행 구분선이 카드 끝까지 닿는 목록형 본문. */
  flush?: boolean
  children: ReactNode
}): JSX.Element => (
  <section className={styles.card} aria-label={typeName ? `${title} ${typeName}` : title}>
    <header className={styles.cardHead}>
      <h3 className={styles.cardTitle}>{title}</h3>
      {typeName ? <span className={styles.typeName}>{typeName}</span> : null}
      {tags ? <span className={styles.cardTags}>{tags}</span> : null}
    </header>
    <div className={flush ? styles.cardBodyFlush : styles.cardBody}>{children}</div>
    {error ? <div className={styles.cardError}>{error}</div> : null}
    {footer ? (
      <footer className={styles.cardFoot}>
        <span className={styles.cardFootNote}>{footerNote}</span>
        {footer}
      </footer>
    ) : null}
  </section>
)

/** 저장 실패 한 줄 — 카드 안 Callout. */
export const SaveErrorCallout = ({ error }: { error: PanelError }): JSX.Element => <Callout tone="crit">{error.message}</Callout>
